import { useLanguage } from '@/hooks/useLanguage'
import { authT } from '../../locale'

export const AuthTerms = () => {
  const { language } = useLanguage()
  const l = authT[language]
  // white by design: renders on the fixed-dark Auth hero, not app surface
  return (
    <p className="text-xs text-white/40 text-center mt-6 leading-relaxed">
      {l.termsBefore}{' '}
      <a
        href="https://learn.open-academy.app/docs/terms-of-use.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white/70 underline underline-offset-2 hover:text-white transition-colors"
      >
        {l.termsLink}
      </a>{' '}
      {l.termsAnd}{' '}
      <a
        href="https://learn.open-academy.app/docs/privacy-policy.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="text-white/70 underline underline-offset-2 hover:text-white transition-colors"
      >
        {l.privacyLink}
      </a>
      .
    </p>
  )
}
